// extracted by mini-css-extract-plugin
export default {"navBtn":"NavigationBtn_navBtn__WppcM","pencil":"NavigationBtn_pencil__6CLaj","pencilLine":"NavigationBtn_pencilLine__MJIyc"};